import { ref, watch, onBeforeMount } from "vue"
import DynamicTable from '../DynamicTable/DynamicTable.vue'
import NykDateTimePicker from "components/CustomForm/NykDateTimePicker/NykDateTimePicker.vue"
import { useForm } from "vee-validate"
import { isScreenWidth } from "../../foundation/js/is-mobile-device.js"
export default {
  name: "HistoricFundPrices",
  components: {
    DynamicTable,
    NykDateTimePicker,
  },
  props: {
    isin: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    isError: {
      type: Boolean,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
    labelsError:{
        type: Object,
        required: true,
    },
  },
  setup(props) {
    const hideError = ref(false)

    const isMobile = isScreenWidth("600")

    const headers = ref([])
    const rows = ref([])

    const mobileTableGroups = ref([])

    const { values, setFieldValue } = useForm({
      initialValues: {
        date: '',
      }
    });

    const buildMobileTableGroup = (rows) => {
      mobileTableGroups.value = rows.map(row => {
        const header = [{name: "Tidspunkt"}, {name: row.date, scope: "row", styles: "text-right"}]
        const rows = [
          [{name: props.headers.nav}, {name: row.nav, styles: "text-right"}],
          [{name: props.headers.sell}, {name: row.sell, styles: "text-right"}],
          [{name: props.headers.buy}, {name: row.buy, styles: "text-right"}],
        ];
        return {
          header: header,
          rows: rows,
        }
      })
    }

    const populateHeaders = () => {
      headers.value.push(
        { name: `${props.isin} ${props.name}`, scope: "row" },
        ...Object.entries(props.headers).map(([key, value], i, arr) => ({
          name: value,
          scope: 'row',
          ...(i === arr.length - 1 ? { styles: "text-right" } : {})
        }))
      );
    };


    const populateRows = (rawRows) => {
      rows.value.push(
        ...rawRows.map(row => ([
          { name: "" },
          { name: row.nav },
          { name: row.sell },
          { name: row.buy },
          { name: row.date, styles: "text-right" }
        ]))
      )
    }

    const updateUrl = (params = {}) => {
      const url = new URL(window.location);
      for (const [key, value] of Object.entries(params)) {
        url.searchParams.set(key, value);
      }
      window.history.replaceState({}, "", url);
    }


    const getTableData = () => {
      const url = new URL(props.apiUrl, window.location.origin)
      url.searchParams.set("isin", props.isin)

      let isoDate = values.date
      if(isoDate.includes("/")) {
        const [day, month, year] = values.date.split('/')
        isoDate = `${year}-${month}-${day}`
      }
      url.searchParams.set("date", isoDate)

      updateUrl({"isin": props.isin, "date": isoDate})

      const request = new Request(url.toString(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })

      fetch(request)
        .then((res) => {
          if (res.ok) {
            return res.json()
          } else {
            throw new Error("Fetch failed..")
          }
        })
        .then((json) => {
          rows.value = []
          populateRows(json)
          buildMobileTableGroup(json)
        })
        .catch((err) => {
          console.error(err)
        })
    }
  
    if(!props.isError) {
      populateHeaders()
      populateRows(props.rows)
      buildMobileTableGroup(props.rows)
    }

    watch(() => values.date, (newDate, oldVal) => {
      getTableData()
    })

    onBeforeMount(() => {
      const params = new URLSearchParams(window.location.search)
      const dateParam = params.get('date')

      if (dateParam) {
        const [year, month, day] = dateParam.split('-')
        const date = `${day}/${month}/${year}`
        setFieldValue('date', date)
      }
    })

    const handleHideSystemErrorMessage = () => {
      hideError.value = !hideError.value
    }

    return {
      isMobile,
      values,
      headers,
      rows,
      mobileTableGroups,
      hideError,
      handleHideSystemErrorMessage,
    }
  },
}
